import { Outlet } from 'react-router-dom';
import { ImportsWizardProvider } from './ImportsWizardContext';

export default function ImportsLayout() {
  return (
    <ImportsWizardProvider>
      <Outlet />
    </ImportsWizardProvider>
  );
}
